module.exports = __webpack_public_path__ + "static/media/task-local.fc3204d7.svg";